import "@babel/polyfill";

import "./script_top.css";
import "./commoncss/loading.css";

import {google} from "../commonjs/google.js";
import {get_device} from "../commonjs/device.js";
import {screen_size} from "../commonjs/canvas_screen.js";

window.onload = function(){
            google();
            document.getElementById(`loading_wall`).style.display = `none`;
            document.getElementById(`load`).style.display = `none`; 
            
            const circle = document.getElementById(`circle`);
            const wall1 = document.getElementById(`wall1`);
            const wall2 = document.getElementById(`wall2`);
            const wall3 = document.getElementById(`wall3`);
            const other_buttom = document.getElementById(`other_bar`);
            const down = document.getElementById(`down`);
            
            const smart_phone = document.getElementById(`smart_phone`);
            const close_bar = document.getElementById(`close_bar`);
            const smartphone_menu_button = document.getElementById(`smartphone_menu_button`);
            
            //indexに移動前のurlを取得して外部リンクからの移動だった場合のみムービーを表示
            const refer = document.referrer.indexOf(`scriptpage`);
            
            
            if(refer === -1){
                createjs_anime();
            }else{
                circle.style.display = `none`;
                slide();
            }
            
            
            
            screen_size(circle);
            
            
            
            function createjs_anime(){
                const stage = new createjs.Stage(`circle`);
                let count = 150;
                let water_circle = [];
                const shape = new createjs.Shape();
                shape.graphics.beginStroke(`#f3facc`);
                shape.graphics.setStrokeStyle(2);
                shape.graphics.drawCircle(0,0,window.innerWidth/15);
                stage.addChild(shape);
                
                shape.x = window.innerWidth/2;
                shape.y = window.innerHeight/2;
                createjs.Tween.get(shape)
                        .to({scaleX: 0, scaleY: 0},1500,createjs.Ease.cubicIn)
                        .to({scaleX:0.8,scaleY:0.8,alpha:0},1500,createjs.Ease.cubicOut)
                        .wait(50)
                        .call(after_wave);
                
                
                function after_wave()  { 
                    /*const click = new createjs.Text(`Click here`,`30px serif`,`white`);
                    
                    
                    click.y = window.innerHeight/2;
                    click.x = window.innerWidth/2;
                    click.alpha = 0;
                    click.textAlign = `center`;
                    stage.addChild(click);
                    
                    createjs.Tween.get(click)
                        .to({alpha:0.7},3000)
                    */
                    
                    setTimeout(()=>{
                        const end_intoroduction = circle.animate([{opacity:1},{opacity:0}],{
                            duration: 700,
                            fill:`forwards`
                        });
                        
                        end_intoroduction.addEventListener(`finish`,()=>{
                            circle.style.display = `none`;
                            slide();
                            createjs.Ticker.reset();
                        },false);
                    },1000);
                }
                
                
                createjs.Ticker.addEventListener(`tick`,ripples);
                
                function ripples(e){
                    
                    if(shape.alpha<0.9){
                        if(e.time%2>0.5){
                            make_waters();
                            waving();  
                        }
                        
                        if(e.time%2>0.5){
                            brightness();
                            lighting();
                        }
                    }
                }
                
                function make_waters(){
                    count++
                    for(let i=0;i<1;i++){
                        
                        const wave = new createjs.Shape();
                        wave.graphics
                            .beginStroke(createjs.Graphics.getHSL(blue_and_breen(count),50,50))
                            .drawCircle(0,0,(Math.random()*50)+Math.round(Math.random())*20);
                        stage.addChild(wave);
                        wave.alpha = 0;
                        wave.x = window.innerWidth/2+adjust_point(100);
                        wave.y = window.innerHeight/2+adjust_point(100);
                        
                        water_circle.push(wave);
                    }
                    
                }
                
                function blue_and_breen(count){
                    
                    if(count>280){
                        count = 180;
                    }
                    return count;
                }
                
                function adjust_point(point){
                  return  -point*Math.random()+point*Math.random();
                }
                
                function waving(){
                    for(let i=0;i<water_circle.length;i++){
                        const peace_water = water_circle[i];
                        
                        createjs.Tween.get(peace_water)
                                .to({alpha:0.6},1000)
                                .to({alpha:0},3000);
                        
                        createjs.Tween.get(peace_water)
                                .to({scaleX:2,scaleY:2},4000);
                        if(peace_water.alpha===0){
                            water_circle.splice(i,1);
                        }
                    }
                }
                
                /*==========================================================*/
                let lights = []
                function brightness(){
                    
                    for(let i=0;i<4;i++){
                        
                        const bright = new createjs.Shape();
                        bright.graphics.beginFill(`white`)
                            .drawCircle(0,0,Math.random()*50);
                        stage.addChild(bright);
                        bright.alpha = 0.05;
                        bright.x = adjust_point(window.innerWidth*2);
                        bright.y = adjust_point(100)+window.innerHeight/2;
                        
                        lights.push(bright);
                    }
                }
                
                function lighting(){
                    for(let i=0;i<lights.length;i++){
                        const highlight = lights[i];
                        
                        createjs.Tween.get(highlight)
                                .to({alpha:0},1500);
                        
                        createjs.Tween.get(highlight)
                                .to({scale:1.5},1500);
                                
                    }
                }
                
                createjs.Ticker.addEventListener(`tick`,stage);
                
                
                
               
            }
            
            other_buttom.addEventListener(`click`,()=>{
                const position_b = parseFloat(document.defaultView.getComputedStyle(document.getElementsByTagName(`selection`)[0],null).bottom);
                
                document.getElementsByTagName(`selection`)[0].animate([{bottom:position_b+`px`},{bottom:`0px`}],{
                    duration : 500,
                    fill :`forwards`
                });
            },false);
            
            down.addEventListener(`click`,()=>{
                const position_b = parseFloat(document.defaultView.getComputedStyle(document.getElementsByTagName(`selection`)[0],null).bottom);
                document.getElementsByTagName(`selection`)[0].animate([{bottom:position_b+`px`},{bottom:`-50px`}],{
                  duration : 500,
                  fill :`forwards`  
                });
            },false);
            
            
            
            /*=================promiseでアニメーション、ループ処理=====================*/
            
            
            function slide(){
                const wall2_in = wall2.animate([{opacity:0},{opacity:1}],{
                    duration : 1000,
                    fill :`forwards`
                });
                
                const wall3_in = wall3.animate([{opacity:0},{opacity:1}],{
                    duration : 1000,
                    fill :`forwards`
                });
                
                
                
                wall2_in.pause();
                wall3_in.pause();
                
                
                const begin = ()=>{
                    return new Promise((resolve,reject)=>{
                        setTimeout(()=>{
                            wall2_in.play();
                            wall2_in.addEventListener(`finish`,()=>{
                                resolve();
                            },false);
                        },4000);
                    });
                };
                
                const middle = ()=>{
                    return new Promise((resolve,reject)=>{
                       setTimeout(()=>{
                           wall3_in.play();
                           wall3_in.addEventListener(`finish`,()=>{
                               resolve();
                           },false);
                       },4000); 
                    });
                };
                
                const last = ()=>{
                    return new Promise((resolve,reject)=>{
                        
                            //アニメーション中に変更したcssはアニメーションでないと変更できない？
                            const wall2_out = wall2.animate([{opacity:1},{opacity:0}],{
                                duration:1,
                                fill:'forwards'
                            })
                        
                        setTimeout(()=>{
                            const wall3_out = wall3.animate([{opacity:1},{opacity:0}],{
                                duration : 1000,
                                fill :`both`
                            });
                            wall3_out.addEventListener(`finish`,()=>{
                                resolve();
                            },false);
                        },4000);
                    });
                };
                
                begin()
                .then(middle)
                .then(last)
                .then(slide);
                
                /*===================================================*/
               
                
                
                
                    
                }
            
            
            /*=========================smart phone=========================*/
                smartphone_menu_button.addEventListener(`click`,()=>{
                    smart_phone.animate([{left:`-100%`},{left:`0px`}],{
                        duration:1000,
                        fill:`forwards`
                    });
                },false);
                
                close_bar.addEventListener(`click`,()=>{
                    const hide = smart_phone.animate([{left:`0px`},{left:`-100%`}],{
                        duration:1000,
                        fill:`forwards`
                    });
                    hide.addEventListener(`finish`,()=>{
                        smart_phone.style.top = `0px`;
                    },false);
                },false);
                
                
                smart_phone.addEventListener(`touchstart`,(e)=>{
                    get_top(smart_phone);
                    
                    smart_phone.setAttribute(`touch_start`,e.touches[0].clientY);
                    smart_phone.addEventListener(`touchmove`,touch_moveY,false);
                },false);
                
                function touch_moveY(e){
                    e.preventDefault();
                    const how_long_move = parseFloat(smart_phone.getAttribute(`top`)) + (e.touches[0].clientY - parseFloat(smart_phone.getAttribute(`touch_start`)));
                    if(how_long_move > 0){
                        return;
                    }
                    smart_phone.style.top =  how_long_move + `px`;
                    smart_phone.addEventListener(`touchend`,(e)=>{
                        smart_phone.removeEventListener(`touchmove`,touch_moveY,false);
                    },false);
                }
            
                function get_top(elm){
                    const rect = elm.getBoundingClientRect();
                    const positionY = !elm.style.top ? `0px` : parseFloat(elm.style.top);
                    elm.setAttribute(`top`,positionY);
                }
            
            
            
        }